import { CommonModule } from '@angular/common';
import { Component, computed, effect, input, signal, TemplateRef } from '@angular/core';
import { RoundedIconButtonComponent } from '@shared/atoms/rounded-icon-button/rounded-icon-button.component';

import {
  buildCardCarouselDisplaySlots,
  cardCarouselGridTemplateColumns,
} from './card-carousel-display-slots';

@Component({
  selector: 'app-card-carousel',
  templateUrl: './card-carousel.component.html',
  imports: [RoundedIconButtonComponent, CommonModule],
})
export class CardCarouselComponent {
  nbDisplayCards = input<number>(4);
  cards = input<unknown[] | undefined | null>([]); // DO3-872, sometimes cards is undefined, I do not know the source of the problem
  scrollInMobile = input<boolean>(false);
  carouselItem = input.required<TemplateRef<unknown>>();
  externalIndex = input<number | undefined>(undefined);
  hideArrows = input<boolean>(false);

  currentIndex = signal(0);

  readonly displaySlots = computed(() =>
    buildCardCarouselDisplaySlots(this.cards(), this.nbDisplayCards(), this.currentIndex()),
  );

  readonly gridTemplateColumns = computed(() =>
    cardCarouselGridTemplateColumns(this.nbDisplayCards()),
  );

  constructor() {
    effect(() => {
      const extIndex = this.externalIndex();
      if (extIndex !== undefined) {
        this.currentIndex.set(extIndex);
      }
    });
  }

  prev(): void {
    this.currentIndex.update(current => (current === 0 ? current : current - 1));
  }

  next(): void {
    const maxIndex = (this.cards()?.length ?? 0) - this.nbDisplayCards();
    this.currentIndex.update(current => (current === maxIndex ? current : current + 1));
  }
}
